import { createFileRoute, notFound } from "@tanstack/react-router";
import { HariPentingPage, buildHariJsonLd } from "@/components/pages/HariPentingPage";
import { getHariPentingBySlug } from "@/data/hari-penting";
import { HARI_CONTENT } from "@/lib/hari-penting/content";
import { MONTH_NAMES_ID } from "@/lib/calendar/dates";

export const Route = createFileRoute("/hari/$slug")({
  loader: ({ params }) => {
    const entry = getHariPentingBySlug(params.slug);
    if (!entry) throw notFound();
    return { entry };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const entry = loaderData.entry;
    const [mm, dd] = entry.monthDay.split("-").map((n) => parseInt(n, 10));
    const monthName = MONTH_NAMES_ID[mm - 1];
    const cy = new Date().getFullYear();
    const content = HARI_CONTENT[entry.slug];
    const title = `${entry.name}, ${dd} ${monthName} ${cy} | Tanggal, Sejarah, Makna`;
    const description =
      content?.quickAnswer ??
      `${entry.name} diperingati setiap tanggal ${dd} ${monthName}. Cek sejarah, makna, dan cara memperingati ${entry.name} ${cy}.`;
    const origin = "";
    const ld = buildHariJsonLd(entry, origin, cy);
    return {
      meta: [
        { title },
        { name: "description", content: description },
        {
          name: "keywords",
          content: [
            entry.name.toLowerCase(),
            `${entry.name.toLowerCase()} tanggal berapa`,
            `${entry.name.toLowerCase()} ${cy}`,
            ...(entry.aliases ?? []),
          ].join(", "),
        },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "article" },
      ],
      links: [{ rel: "canonical", href: `https://hari.co.id/hari/${entry.slug}/` }],
      scripts: ld.map((obj) => ({
        type: "application/ld+json",
        children: JSON.stringify(obj),
      })),
    };
  },
  component: HariSlugComponent,
  notFoundComponent: () => (
    <div className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-2xl font-bold">Hari peringatan tidak ditemukan</h1>
      <p className="mt-2 text-muted-foreground">
        Coba lihat <a href="/hari" className="text-primary hover:underline">daftar lengkap hari penting</a>.
      </p>
    </div>
  ),
});

function HariSlugComponent() {
  const { entry } = Route.useLoaderData();
  return <HariPentingPage entry={entry} />;
}